import { getLocationPointCityName } from '../index';
import toString from './toString';

function toStringLocationAddressWithCityAndCountry(location, countryName) {
  if (location) {
    const cityName = getLocationPointCityName(location);
    let address = toString(location);
    if (address) {
      if (cityName) address = `${address}, ${cityName}`;
      if (countryName) address = `${address}, ${countryName}`;
    }
    return address;
  }
  return '';
}

export default toStringLocationAddressWithCityAndCountry;
